import { EditableText, defineBlock } from "eddev/blocks"
import { useHydrating } from "eddev/routing"
import { useCategories } from "@hooks/queries"
import { Fragment } from "react"
import { Button } from "@components/atoms/Button"
import { VSpace } from "@components/layout/Spacer"
import { Col, Container, Grid } from "@components/layout/Grid"
import { useIsMobile } from "@hooks/useViewportDerived"

export const meta: BlockMeta = {
  title: "Category filter",
  category: "common",
  icon: "filter",
  keywords: ["filter"],
  tags: ["root"],
  editMode: "preview",
  lazyLoad: false,
  conditions: {
    postTypes: ["page", "post"],
    multiple: false,
  },
}

export default defineBlock("news/category-filter", (props) => {
  const categories = useCategories().data?.categories?.nodes
  const isMobile = useIsMobile()
  const hydrating = useHydrating()

  return (
    <div className="bg-yellow py-7 text-center my-4 wp:w-full wp:[&_.--grid]:w-full">
      <Container>
        <Grid>
          {!isMobile && <Col initial={12} tablet={1} laptop={2} className="wp:w-full wp:ml-0" />}
          <Col initial={12} tablet={10} laptop={8} className="wp:w-full wp:ml-0">
            <EditableText as="h4" placeholder="Browse by..." store="title" />
            <VSpace initial={5} />

            <div className="flex flex-wrap justify-center [&_button]:m-1 [&_a]:m-1">
              {!hydrating &&
                categories
                  ?.filter((category) => category.slug !== "uncategorized")
                  .map((category, i) => (
                  <Fragment key={i}>
                    <Button
                      color="outlineYellow"
                      size="small"
                      href={`/newsroom/news-archive/?categories=${category.slug}`}
                    >
                      {category.name}
                    </Button>
                  </Fragment>
                ))}
              <Button color="black" size="small" href="/newsroom/news-archive">
                View all
              </Button>
            </div>
          </Col>
        </Grid>
      </Container>
    </div>
  )
})
